import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgTickets = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 29 21" {...props}>
    <g fill="none" fillRule="evenodd" stroke="#4D4D4D">
      <rect width={27.875} height={20} x={0.5} y={0.5} rx={3} />
      <path d="m2.867 3.388 11.918 6.167 11.074-6.167" />
    </g>
  </svg>
);
const Memo = memo(SvgTickets);
export default Memo;
